import { SalesPersonDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'

export const projectSalesRepresentativeSelector: (
  state: RootAppState
) => SalesPersonDto | undefined = (state: RootAppState) =>
  state.project.activeProject?.salesPerson
